module.exports = __webpack_public_path__ + "media/src/StayPackage/images/image-29fa51683ebebeeea4a1a6c2605e8092.svg";